const baseURL = process.env.REACT_APP_API_BASE_URL;
const actions = {
  getPageConfig: (data) => ({
    method: "get",
    url: "page/retrieve",
  }),
  initSubscription: (data) => ({
    method: "post",
    url: "dcb/inaugurate",
  }),
  listenSubscription: (data) => ({
    method: "post",
    url: "dcb/sync",
  }),
  lookup: (data) => ({
    method: "post",
    url: "account/lookup",
  }),
  saveTraffic: (data) => ({
    method: "post",
    url: "traffic/record",
  }),
  verifyOTP: (data) => ({
    method: "post",
    url: "dcb/confirm",
  }),
  partnerRegistration: (data) => ({
    method: "post",
    url: "partners/register",
  }),
  confirmRegistration: (data) => ({
    method: "post",
    url: "partners/confirm-registration",
  }),
  getRegistrationUrl: (data) => ({
    method: "post",
    url: "partners/get-registration-url"
  }),
  unsubscribe: (data) => ({
    method: "post",
    url: "dcb/unsubscribe"
  }),
};

const callAPI = (data, type) => {
  var myHeaders = new Headers();
  let dt = actions[type](data);
  let body;

  if (!data.web_click_id)
    data.web_click_id = localStorage.getItem("nj_clickId");

  if (!data.config_id) data.config_id = localStorage.getItem("nj_configId");

  myHeaders.append("Content-Type", "application/json");
  body = JSON.stringify(data);

  var requestOptions = {
    method: dt.method,
    headers: myHeaders,
    redirect: "follow",
  };
  if (body && dt.method !== "get") {
    requestOptions.body = body;
  }
  if (dt.method === "get" && data) {
    const query = Object.keys(data)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(data[k]))
      .join("&");
    dt.url += "?" + query;
  }

  return fetch(baseURL + dt.url, requestOptions)
    .then((resp) => resp.json())
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      throw new Error(error);
    });
};

export default callAPI;
